import React from "react";
import PropTypes from "prop-types";
import FormItemLabelWithHelp from "./form-item-label-with-help";

const FullTextHelp = ({ label = "Full Text" }) => {
  const fullTextHelp = (
    <table>
      <tbody>
        <tr>
          <td>
            <strong>Symbol</strong>
          </td>
          <td>
            <strong>Operation</strong>
          </td>
        </tr>
        <tr>
          <td>
            <code>&quot;</code>
          </td>
          <td>exact phrase</td>
        </tr>
        <tr>
          <td>
            <code>+</code> or <code>&lt;space&gt;</code>
          </td>
          <td>AND</td>
        </tr>
        <tr>
          <td>
            <code>|</code>
          </td>
          <td>OR</td>
        </tr>
        <tr>
          <td>
            <code>-</code>
          </td>
          <td>NOT</td>
        </tr>
        <tr>
          <td>
            <code>( )</code>
          </td>
          <td>groups search terms or operations</td>
        </tr>
        <tr>
          <td>
            <a href="https://support.unifiedpatents.com/hc/en-us/articles/8263935234071" target="_blank" rel="noopener noreferrer">
              More details here.
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );

  return (
    <FormItemLabelWithHelp label={label} title="Advanced Query Syntax" content={fullTextHelp} />
  );
};

FullTextHelp.propTypes = {
  label: PropTypes.node
};

export default FullTextHelp;
